import { useState, React } from "react";
import { IoChevronDown } from "react-icons/io5";
import ButtonDKN from "../../Button/ButtonDKN";
import pat1 from "../../../assets/images/Solution/pat1.svg";
import pat2 from "../../../assets/images/Solution/pat2.svg";
import pat3 from "../../../assets/images/Solution/pat3.svg";
import pat4 from "../../../assets/images/Solution/pat4.svg";
import pat5 from "../../../assets/images/Solution/pat5.svg";
import pat6 from "../../../assets/images/Solution/pat6.svg";
import pat7 from "../../../assets/images/Solution/pat7.svg";
import pat8 from "../../../assets/images/Solution/pat8.svg";

export default function SolutionOutstanding() {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (id) => {
    setOpenDropdown((prev) => (prev === id ? null : id));
  };

  const dropdownItems = [
    {
      id: 1,
      title: "CRM",
      image: pat1,
      content: [
        "Quản lý thông tin và lịch sử chăm sóc lead.",
        "Lọc, theo dõi, thống kê lead theo trạng thái, nguồn và chiến dịch Marketing.",
        "Quản lý lịch làm việc và phân công nhiệm vụ nhân viên.",
      ],
    },
    {
      id: 2,
      title: "Quản lý ghi danh",
      image: pat2,
      content: [
        "Quản lý ghi danh theo gói phí, đơn hàng và phiếu thu.",
        "Quản lý khuyến mãi và voucher.",
        "Quản lý cấp phát học liệu, quà tặng.",
      ],
    },
    {
      id: 3,
      title: "Quản lý giảng dạy",
      image: pat3,
      content: [
        "Quản lý  chương trình, cấp độ, khoá học, lớp học, phòng học, ca học và lịch học.",
        "Quản lý tiến trình học tập và tài liệu giảng dạy.",
        "Quản lý ma trận, ngân hàng câu hỏi và phân quyền tài liệu.",
      ],
    },
    {
      id: 4,
      title: "Quản lý học tập",
      image: pat4,
      content: [
        "Giao bài tập, tạo đề theo Ma trận và chấm bài tự động.",
        "Đánh giá, nhận xét tự động theo buổi, tuần, tháng và kỳ đánh giá.",
        "Đánh giá năng lực và đánh giá quá trình học tập tự động.",
        "Làm bài, nhận kết quả học tập tự động trên hệ thống.",
      ],
    },
    {
      id: 5,
      title: "Quản lý Học viên",
      image: pat5,
      content: [
        "Quản lý điểm danh tự động qua Camera.",
        "Quản lý tiến trình học tập, lịch sử học tập, kết quả và đánh giá học tập.",
        "Quản lý lịch sử chăm sóc.",
        "Quản lý bảo lưu, chuyển lớp, chuyển phí, rút phí.",
      ],
    },
    {
      id: 6,
      title: "Quản lý giáo viên, trợ giảng",
      image: pat6,
      content: [
        "Quản lý và theo dõi lịch giảng dạy.",
        "Quản lý giờ dạy và đánh giá chất lượng giáo viên.",
      ],
    },
    {
      id: 7,
      title: "Quản lý báo cáo",
      image: pat7,
      content: [
        "Báo cáo kinh doanh: Chi tiết theo nguồn, chi nhánh, công nợ và tỷ lệ hoàn thành.",
        "Báo cáo doanh thu theo đơn hàng và phiếu thu.",
        "Báo cáo doanh thu thực hiện.",
        "Báo cáo vận hành ACS, báo cáo lớp học, báo cáo học viên Active, Pending.",
      ],
    },
    {
      id: 8,
      title: "Mobile app Học viên/ Phụ huynh",
      image: pat8,
      content: [
        "Sổ liên lạc điện tử.",
        "Tương tác trực tiếp với giáo viên và lớp học.",
        "Làm bài tập, bài thi và nhận kết quả trên App.",
        "Nhận thông báo điểm danh, nhiệm vụ học tập, báo cáo học tập tuỳ chỉnh.",
        "Cập nhập thông tin số dư học phí, số buổi học, hoá đơn và phiếu thu.",
        "Mạng xã hội hỏi đáp 24/7.",
      ],
    },
    {
      id: 9,
      title: "Mobile app Giáo viên",
      image: pat8,
      content: [
        "Cập nhập thông tin lịch giảng dạy, tiến trình bài giảng và lớp học.",
        "Nhận báo cáo hoạt động làm bài, kết quả làm bài của học viên.",
        "Tương tác trực tiếp với học viên/phụ huynh trên App.",
      ],
    },
    {
      id: 10,
      title: "Mobile app BOD",
      image: pat8,
      content: [
        "Cập nhập báo cáo tài chính và báo cáo vận hành của trung tâm.",
        "Cập nhật báo cáo biến động theo ngày.",
        "Tùy chỉnh thông báo theo các thông số cài đặt.",
      ],
    },
  ];

  const renderDropdown = (items) => (
    <div className="w-full flex flex-col gap-6">
      {items.map((item) => (
        <div key={item.id}>
          {/* Dropdown Header */}
          <div
            className="flex items-center justify-between bg-[#e6ecfa] border-b-2 border-[#CDD8F4] p-2 rounded-lg cursor-pointer"
            onClick={() => toggleDropdown(item.id)}
          >
            <div className="flex items-center gap-4">
              {/* Image */}
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#cdd8f4]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-6 h-6 rounded-md"
                />
              </div>

              {/* Title */}
              <span className=" font-medium text-[#1F1F1F] text-[18px]">
                {item.title}
              </span>
            </div>
            {/* Arrow Icon */}
            <IoChevronDown
              className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${
                openDropdown === item.id ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>

          {/* Dropdown Content */}
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openDropdown === item.id ? "max-h-screen" : "max-h-0"
            }`}
          >
            <div className="p-4 bg-white shadow-custom-light rounded-[8px] border-4 border-solid border-[#E6ECFA] mt-2">
              <ul className="list-disc list-inside text-[#053CC8] text-[16px] font-normal">
                {item.content.map((point, index) => (
                  <li key={index} className="mb-2">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="w-full bg-[#f4f8ff] md:mt-10 ">
      <div className="w-full container mx-auto px-[20px] rounded-[16px] py-[20px] flex flex-col items-center justify-center gap-3 md:gap-10 bg-gradient3">
        <div className="w-full md:text-center">
          <p className="text-[#053CC8] font-semibold text-[32px]">
            Tính năng nổi bật của Blue Rise
          </p>
          <p className="text-[16px] text-[#333333] font-normal">
            <span className="font-bold">Blue Rise</span> cung cấp một loạt các
            tính năng mạnh mẽ, giúp các trung tâm giáo dục quản lý hiệu quả và
            phát triển toàn diện.
          </p>
        </div>

        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-3 lg:gap-8">
          {/* Section for id="me" */}
          <div id="me">
            {renderDropdown(
              dropdownItems.filter((item) => item.id >= 1 && item.id <= 5)
            )}
          </div>
          {/* Section for id="mo" */}
          <div id="mo">
            {renderDropdown(
              dropdownItems.filter((item) => item.id >= 6 && item.id <= 10)
            )}
          </div>
        </div>

        <div className="w-full flex items-center justify-center lg:w-[300px] ">
          <ButtonDKN txt=" Đăng ký dùng thử miễn phí" cl="w-full hover:bg-pa" />
        </div>
      </div>
    </div>
  );
}
